import React from 'react';

import styled from 'styled-components';

import { Animation } from 'components/lottie-animations/favorite-loading';

const IconWrapper = styled.div`
  height: 44px;
  width: 44px;
  padding: 8px;
`;

const LoadingAnimation = () => (
  <IconWrapper>
    <Animation />
  </IconWrapper>
);

export default LoadingAnimation;
